// extracted by mini-css-extract-plugin
export default {"container":"notificationIcon_container__axIfl","circle":"notificationIcon_circle__Kml0a","warningIcon":"notificationIcon_warningIcon__l-do3"};